import { BofSearchMatchDto, BofSearchTournamentDto } from '@/api/player-api/api-models'
import { CasinoGameItem } from '@/features/casino/casino.model'

interface SearchItemBase {
	/** Stable identity across sections, used as the @for track key. */
	key: string
	/** Display text, resolved once at map time. */
	label: string
	/** Position in the flattened list, so keyboard nav needs no offset maths. */
	flatIndex: number
	/** Icon or thumbnail URL, resolved once at map time. Empty when there is none. */
	imageUrl: string
}

export interface SearchMatchItem extends SearchItemBase {
	type: 'match'
	/** Currently in play; drives the live indicator and the running clock. */
	isLive: boolean
	/** "Category / Tournament", e.g. "Italy / Seria A". */
	league: string
	/** Kick-off time when today, otherwise the date. Empty for live matches. */
	startLabel: string
	data: BofSearchMatchDto
}

export interface SearchTournamentItem extends SearchItemBase {
	type: 'tournament'
	data: BofSearchTournamentDto
}

export interface SearchGameItem extends SearchItemBase {
	type: 'game'
	/** Who made the game. Empty when the API does not know it. */
	providerName: string
	/** The main casino category the game was found in, e.g. "Live Casino". */
	category: string
	/** How many players marked the game as favorite. */
	followers: number
	/** Return to player in percent. Null when the provider does not state it. */
	rtp: number | null
	/** Players in the game for real money right now. */
	playing: number
	data: CasinoGameItem
}

export type SearchItem = SearchMatchItem | SearchTournamentItem | SearchGameItem

export interface SearchSection {
	key: string
	/** Transloco key for the section heading. */
	titleKey: string
	items: SearchItem[]
}

export interface SearchView {
	sections: SearchSection[]
	flatItems: SearchItem[]
	totalCount: number
}

export const EMPTY_SEARCH_VIEW: SearchView = {
	sections: [],
	flatItems: [],
	totalCount: 0
}
